import { render, staticRenderFns } from "./ParentContentsPage.vue?vue&type=template&id=72e23f03&"
import script from "./ParentContentsPage.vue?vue&type=script&lang=js&"
export * from "./ParentContentsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports